import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface JobCardReportRequest {
  areaId: number | null | undefined;
  departmentId: number | null | undefined;
  employeeId: number | null | undefined;
  jobCardStatus: string | null | undefined;
  complaintStatus: string | null | undefined;
  startDate: Date | null | undefined;
  endDate: Date | null | undefined;
  categoryId: number | null | undefined;
  masterComplaintId: number | null | undefined;
  complaintDescription: string | null | undefined;
}


@Injectable({
  providedIn: 'root',
})
export class ReportService {
  private apiUrl = environment.apiUrl + '/reports/v1/download';

  constructor(private http: HttpClient) {}

  downloadUserRequestPDF(userName: string) {
    return this.http.get(`${this.apiUrl}/user-registration/${userName}`, {
      responseType: 'blob', // To handle binary data (PDF)
      observe: 'response',
    });
  }

  generateJobCardReport(jobCardReportRequest: JobCardReportRequest) {
    return this.http.post(`${this.apiUrl}/job-card-report`, jobCardReportRequest, {
      responseType: 'blob', // To handle binary data (PDF)
      observe: 'response',
    });
  }

  generateComplaintReport(jobCardReportRequest: JobCardReportRequest) {
    return this.http.post(`${this.apiUrl}/complaint-report`, jobCardReportRequest, {
      responseType: 'blob', // To handle binary data (PDF)
      observe: 'response',
    });
  }

  getComplaintReport(requestVo: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/complaint-report`, requestVo, { responseType: 'blob' });
  }

  downloadReport(reportName: string, params: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/report/${reportName}`, params, { responseType: 'blob' });
  }
}
